module.exports = __webpack_public_path__ + "img/1x.379ddbd.jpg";